import { GET_PRESS } from "."

export const getPress = action => {
    return {
        type: GET_PRESS,
        action
    }
}